// API base URL — set VITE_API_BASE_URL in .env.local for development
// Prod value is injected at build time via Vercel environment variables
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? "http://127.0.0.1:8002/api/v1/";

export const API_BASE_URL = apiBaseUrl;
export const SITE_URL = import.meta.env.VITE_SITE_URL ?? "http://localhost:5173";
